import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReorderPlanReviewSubmissionTypesMutationVariables = Types.Exact<{
  updates: Array<Types.Plan_Review_Submission_Types_Updates> | Types.Plan_Review_Submission_Types_Updates;
}>;


export type ReorderPlanReviewSubmissionTypesMutation = { __typename?: 'mutation_root', update_plan_review_submission_types_many?: Array<{ __typename?: 'plan_review_submission_types_mutation_response', affected_rows: number } | null> | null };


export const ReorderPlanReviewSubmissionTypesDocument = gql`
    mutation reorderPlanReviewSubmissionTypes($updates: [plan_review_submission_types_updates!]!) {
  update_plan_review_submission_types_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type ReorderPlanReviewSubmissionTypesMutationFn = Apollo.MutationFunction<ReorderPlanReviewSubmissionTypesMutation, ReorderPlanReviewSubmissionTypesMutationVariables>;

/**
 * __useReorderPlanReviewSubmissionTypesMutation__
 *
 * To run a mutation, you first call `useReorderPlanReviewSubmissionTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPlanReviewSubmissionTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPlanReviewSubmissionTypesMutation, { data, loading, error }] = useReorderPlanReviewSubmissionTypesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useReorderPlanReviewSubmissionTypesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderPlanReviewSubmissionTypesMutation, ReorderPlanReviewSubmissionTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderPlanReviewSubmissionTypesMutation, ReorderPlanReviewSubmissionTypesMutationVariables>(ReorderPlanReviewSubmissionTypesDocument, options);
      }
export type ReorderPlanReviewSubmissionTypesMutationHookResult = ReturnType<typeof useReorderPlanReviewSubmissionTypesMutation>;
export type ReorderPlanReviewSubmissionTypesMutationResult = Apollo.MutationResult<ReorderPlanReviewSubmissionTypesMutation>;
export type ReorderPlanReviewSubmissionTypesMutationOptions = Apollo.BaseMutationOptions<ReorderPlanReviewSubmissionTypesMutation, ReorderPlanReviewSubmissionTypesMutationVariables>;